export interface JourneyNodeProps {
  /** Step number (1-based) */
  index: number;
  /** Hex accent color */
  color: string;
}

/** Typographic step number, no states, no pulse, no progression. */
export function JourneyNode({ index, color }: JourneyNodeProps) {
  return (
    <span
      className="block font-mono text-2xl font-semibold leading-none tabular-nums"
      style={{ color }}
    >
      {String(index).padStart(2, "0")}
    </span>
  );
}
